var map = {
	"./Bundala.png": 348,
	"./GalwaysLand.png": 350,
	"./Hikkaduwa.png": 351,
	"./Horagolla.png": 352,
	"./HortonPlains.png": 353,
	"./Kaudulla.png": 354,
	"./Kumana.png": 362,
	"./Lahugala.png": 355,
	"./Lunugamvehera.png": 356,
	"./MaduruOya.png": 357,
	"./Minneriya.png": 358,
	"./Udawalawa.png": 359,
	"./Wasgamuwa.png": 360,
	"./Wilpattu.png": 361,
	"./flood-plains.jpg": 349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;